export * as Getter from '@biruni/core/get/mod';
